import React, {ReactElement} from 'react';
import {strings} from "../../strings/strings";
import file_download from '../../images/file_download.svg'
import "./index.scss";

export const ImportantInfo = ():ReactElement => {

    return (
        <>
            <h3 className='important-info__title'>{strings.importantInfo}</h3>
            <div className={'info-block'}>
                <img src={file_download} alt="icon"/>
                <div className={'info-block__text'}>
                    <span onClick={() => {window.open(`${process.env.PUBLIC_URL}/resources/product_conditions_travel.pdf`);}}
                        className={'info-block__text--header'}>
                            {strings.policyTermsFile}
                    </span>
                    <span className={'info-block__text--label'}>{".pdf"}</span>
                </div>
            </div>
        </>

    )

}
